import LateOrdersDiagnosis from "../components/UseCases/LateOrdersDiagnosis";
import TariffImpactModelling from "../components/UseCases/TrarrifImpactModelling";
import PatientFlowOptimisation from "../components/UseCases/PatientFlowOptimisation";
import RouteOptimisation from "../components/UseCases/RouteOptimisation";
import LegacySystemRiskMitigation from "../components/UseCases/LegacySystemRiskMitigation";
import RiskModelRapidPrototyping from "../components/UseCases/RiskModelRapidPrototyping";
import CustomerFlowOptimisation from "../components/UseCases/CustomerFlowOptimisation";
// import PensionFundAnalyser from "../components/UseCases/Pensionfundanalyser";
import SurgicalOutcomeAnalytics from "../components/UseCases/SurgicalOutcomeAnalytics";
import ClaimsProcessingAI from "../components/UseCases/ClaimsProcessingAI";
import CustomerLifetimeValue from "../components/UseCases/CustomerLifetimeValue";
import FoodOptimiserMissionControl from "../components/UseCases/FoodOptimiserMissionControl";
import TrainReroutingOptimization from "../components/UseCases/TrainReroutingOptimization";
import ProductionLineResilience from "../components/UseCases/ProductionLineResilience";
import CustomerOnboardingOptimisation from "../components/UseCases/CustomerOnboardingOptimisation";
import CustomerSupportResolution from "../components/UseCases/CustomerSupportResolution";
import EnergyGridLoadBalancing from "../components/UseCases/EnergyGridLoadBalancing";
import ClinicalTrialPatientFlow from "../components/UseCases/ClinicalTrialPatientFlow";
import PortContainerVisibility from "../components/UseCases/PortContainerVisibility";
import WorkforceCapacityPlanning from "../components/UseCases/WorkforceCapacityPlanning";
import ITAssetDependencyMapping from "../components/UseCases/ITAssetDependencyMapping";
import ConstructionProjectRisk from "../components/UseCases/ConstructionProjectRisk";
import AIReadinessAssessment from "../components/UseCases/AIReadinessAssessment";

export const previewUseCases = [{
  p: "late-orders-diagnosis",
  c: LateOrdersDiagnosis,
  d: 1,
  t: "Diagnosing Late Orders",
  cat: "Retail",
  ty: "Diagnostic"
}, {
  p: "tariff-impact-modelling",
  c: TariffImpactModelling,
  d: 2,
  t: "Tariff Impact Modelling",
  cat: "Manufacturing",
  ty: "Simulation"
}, {
  p: "patient-flow-optimisation",
  c: PatientFlowOptimisation,
  d: 3,
  t: "Patient Flow Optimisation",
  cat: "Healthcare",
  ty: "Optimisation"
}, {
  p: "route-optimisation",
  c: RouteOptimisation,
  d: 4,
  t: "Route Optimisation",
  cat: "Transport/Property",
  ty: "Optimisation"
}, {
  p: "legacy-system-risk-mitigation",
  c: LegacySystemRiskMitigation,
  d: 5,
  t: "Legacy System Risk",
  cat: "Transport/Property",
  ty: "Diagnostic"
}, {
  p: "risk-model-rapid-prototyping",
  c: RiskModelRapidPrototyping,
  d: 6,
  t: "Risk Model Rapid Prototyping",
  cat: "Finance",
  ty: "Simulation"
}, {
  p: "customer-flow-optimisation",
  c: CustomerFlowOptimisation,
  d: 7,
  t: "Customer Flow Optimisation",
  cat: "Retail",
  ty: "Optimisation"
},
//   {
//   p: "pension-fund-analyser",
//   c: PensionFundAnalyser,
//   d: 8,
//   t: "Pension Fund Analyser",
//   cat: "Finance",
//   ty: "Simulation"
// },
  {
  p: "surgical-outcome-analytics",
  c: SurgicalOutcomeAnalytics,
  d: 8,
  t: "Surgical Outcome Analytics",
  cat: "Healthcare",
  ty: "Diagnostic"
}, {
  p: "claims-processing-ai",
  c: ClaimsProcessingAI,
  d: 9,
  t: "Claims Processing AI",
  cat: "Finance",
  ty: "Optimisation"
}, {
  p: "customer-lifetime-value",
  c: CustomerLifetimeValue,
  d: 10,
  t: "Customer Lifetime Value",
  cat: "Retail",
  ty: "Diagnostic"
}, {
  p: "food-optimisation-mission-control",
  c: FoodOptimiserMissionControl,
  d: 11,
  t: "Food Distribution",
  cat: "Transport/Property",
  ty: "Mission Control"
}, {
  p: "train-rerouting",
  c: TrainReroutingOptimization,
  d: 12,
  t: "Train Rerouting",
  cat: "Transport",
  ty: "Prescriptive"
}, {
  p: "production-line-resilience",
  c: ProductionLineResilience,
  d: 13,
  t: "Production Line Resilience",
  cat: "Manufacturing",
  ty: "Simulation"
}, {
  p: "customer-onboarding-optimisation",
  c: CustomerOnboardingOptimisation,
  d: 14,
  t: "Customer Onboarding",
  cat: "Finance",
  ty: "Simulation"
}, {
  p: "customer-support-resolution",
  c: CustomerSupportResolution,
  d: 15,
  t: "Customer Support",
  cat: "Retail",
  ty: "Simulation"
}, {
  p: "energy-grid-load-balancing",
  c: EnergyGridLoadBalancing,
  d: 16,
  t: "Energy Grid",
  cat: "Utilities",
  ty: "Simulation"
}, {
  p: "clinical-trial-patient-flow",
  c: ClinicalTrialPatientFlow,
  d: 17,
  t: "Clinical Trial Patient Flow",
  cat: "Healthcare",
  ty: "Simulation"
}, {
  p: "port-container-visibility",
  c: PortContainerVisibility,
  d: 18,
  t: "Port Container Visibility",
  cat: "Logistics",
  ty: "Simulation"
}, {
  p: "workforce-capacity-planning",
  c: WorkforceCapacityPlanning,
  d: 19,
  t: "Workforce Capacity Planning",
  cat: "HR Operations",
  ty: "Simulation"
}, {
  p: "it-asset-dependency-mapping",
  c: ITAssetDependencyMapping,
  d: 20,
  t: "IT Asset Dependency",
  cat: "Technology",
  ty: "Simulation"
}, {
  p: "construction-project-risk",
  c: ConstructionProjectRisk,
  d: 21,
  t: "Construction Project Risk",
  cat: "Construction",
  ty: "Simulation"
}, {
  p: "ai-readiness-assessment",
  c: AIReadinessAssessment,
  d: 22,
  t: "AI Readiness Assessment",
  cat: "Strategy",
  ty: "Simulation"
}];